import React, { useMemo } from 'react'
import ContextMenu from 'tyan/public/components/Form/Block/base/ContextMenu'

const CellContextMenu = props => {
	const { schedule, contextMenu, onGetData } = props

	const target = useMemo(() => `#${schedule && schedule.id || 'schedule'}`, [schedule])

	const handleGetData = selectedTarget => {
		const { startTime, endTime, groupIndex } = schedule.getCellDetails(selectedTarget)
		const { startTime: fieldStartTime, endTime: fieldEndTime } = schedule.eventFields
		const { groupData = {}/* , resourceData  */ } = schedule.getResourcesByIndex(groupIndex) || {}
		const data = {
			...groupData,
			[fieldStartTime]: startTime,
			[fieldEndTime]: endTime,
			// resourceData
		}
		// console.log('data:', data)
		return onGetData ? onGetData(data) : data
	}

	return schedule && <ContextMenu target={target} filter='e-work-cells' contextMenu={contextMenu} onGetData={handleGetData} /> || null
}

export default CellContextMenu